import React, { Component } from 'react';

import {
	CategoryPill,
	TextWrapper,
	Bold,
	CategoryNameWrapper,
	TrophyIconWrapper,
	FireIconWrapper,
	StarIconWrapper,
	NoCountSpace,
} from './CategorySelectorStyles.tsx';
import { TrophyIcon } from './assets/TrophyIcon.tsx';
import { FireIcon } from './assets/FireIcon.tsx';
import { MyTemplatesStarIcon } from './assets/MyTemplatesStarIcon.tsx';
import type { Category } from './types.ts';
import { i18n } from './i18n.ts';

type ItemProps = {
	category: Category;
	isSelected?: boolean;
	isDisabled?: boolean;
	onClick: (category: Category) => void;
};

export class CategoryItem extends Component<ItemProps> {
	handleClick = (): void => {
		if (this.props.isDisabled) {
			return;
		}
		this.props.onClick(this.props.category);
	};

	handleMouseDown = (event: React.MouseEvent<HTMLElement>): void => {
		event.preventDefault();
	};

	getStyledCategoryName = (category: Category): string | React.JSX.Element => {
		if (category.id === 'template.category.featured') {
			return (
				<CategoryNameWrapper>
					<TrophyIconWrapper data-testid="trophy-icon">
						<TrophyIcon />
					</TrophyIconWrapper>
					{i18n.featuredCategoryName.defaultMessage}
				</CategoryNameWrapper>
			);
		} else if (category.id === 'template.category.popular') {
			return (
				<CategoryNameWrapper>
					<FireIconWrapper data-testid="fire-icon">
						<FireIcon />
					</FireIconWrapper>
					{i18n.popularCategoryName.defaultMessage}
				</CategoryNameWrapper>
			);
		} else if (category.id === 'template.category.my-templates') {
			return (
				<CategoryNameWrapper>
					<StarIconWrapper data-testid="star-icon">
						<MyTemplatesStarIcon />
					</StarIconWrapper>
					{i18n.myTemplatesCategoryName.defaultMessage}
				</CategoryNameWrapper>
			);
		} else {
			return category.name;
		}
	};

	render(): React.JSX.Element {
		const { isSelected, isDisabled, category } = this.props;

		const categoryName = this.getStyledCategoryName(category);

		return (
			<CategoryPill
				isSelected={isSelected}
				isDisabled={isDisabled}
				onClick={this.handleClick}
				onMouseDown={this.handleMouseDown}
				{...(isSelected ? { 'data-testid': 'selected-item' } : {})}
				tabIndex={isDisabled ? -1 : 0}
				role="checkbox"
				aria-checked={isSelected}
				aria-disabled={isDisabled}
			>
				<TextWrapper>{categoryName}</TextWrapper>
				{category.count !== undefined && category.count >= 1 ? (
					<Bold>{category.count || ''}</Bold>
				) : (
					<NoCountSpace />
				)}
			</CategoryPill>
		);
	}
}
